import * as React from 'react';
import {connect} from 'react-redux';
import {Async} from '../reusableComponents/Async';
import {Loader} from '../reusableComponents/Loader/Loader';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {BasePage} from '../reusableComponents/BasePage';
import {Icon} from '../reusableComponents/Icon';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {getCurrentUserUUID} from '../../utils/generalUtils';
import {OrgModel} from '../../model/OrgModel';
import {getOrgDetails} from '../../services/organizationService';
import {DeleteOrganizationDialog} from './DeleteOrganizationDialog';

export interface IOrgDetailsPageProps {
    id: string;
    instance: OrgModel;
    history: IHistory;
}

export interface IOrgDetailsPageState {
    open: boolean;
    isOrgActive: boolean;
    oldOrgStatus: boolean;
}

export class OrgDetailsPageImpl extends React.PureComponent<IOrgDetailsPageProps, IOrgDetailsPageState> {
    constructor(props: IOrgDetailsPageProps) {
        super(props);
        this.state = {
            open: false,
            isOrgActive: props && props.instance && props.instance.props.IsActive,
            oldOrgStatus: props && props.instance && this.props.instance.props.IsActive
        };
    }

    public promise = async () => {
        await getOrgDetails(this.props.id);
    }

    orgActiveSwitchChange = (status, isWindowToOpen?: boolean) => {
        this.setState({
            isOrgActive: status
        }, () => {
            this.setState({
                open: isWindowToOpen
            });
        });
    }

    public renderDetails = () => {
        if (!this.props.instance) {
            return <Loader type="async"/>;
        }
        const {OrganizationName, IsActive, Link} = this.props.instance.props;
        const isAdmin = getCurrentUserUUID() === (this.props.instance ? this.props.instance.props.id : '');
        return <div className="details-page">
            <div className="container">
                <DetailsRow label="Name:" value={OrganizationName}/>
                {Link && <ImageDetailsRow label="Logo:" link={Link}/>}
            </div>
            <div className="options-container">
                {isAdmin ? '' :
                    <div className="delete" onClick={() => this.orgActiveSwitchChange(!IsActive, true)}>
                        <Icon icon="trash"/>
                        &nbsp;
                        {IsActive ? 'Deactivate' : 'Activate'}
                    </div>}
                <div className="add-new"
                     onClick={() => this.props.history.push(`/org/edit/${this.props.instance.props.id}`)}>
                    <Icon icon="pencil-alt"/>
                    &nbsp;
                    Edit
                </div>
            </div>
        </div>;
    }

    public render() {
        return <BasePage
            title={this.props.instance ?
                `${(this.props.instance && this.props.instance.props.OrganizationName) + `'s`} Details`
                : 'Organization Details'} icon={'building'}>
            <DeleteOrganizationDialog
                history={this.props.history}
                onClose={() => this.orgActiveSwitchChange(this.state.oldOrgStatus, false)}
                open={this.state.open}
                orgStatus={this.state.isOrgActive}
                instance={this.props.instance}/>
            <Async
                identifier="Organization Details Page"
                promise={this.promise}
                loader={<Loader type="async"/>}
                content={this.renderDetails()}
                error={<ErrorPage/>}
            />
            <div className="options-container">
                {/* <div className="delete" >
                    <Icon icon="trash" />
                    &nbsp;
                    Delete
                </div> */}
            </div>
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    return {
        id: ownProps.match.params.id,
        instance: OrgModel.get(ownProps.match.params.id),
    };
}

export const OrgDetailsPage =
    withRouter(connect<{}, {}, IOrgDetailsPageProps>(mapStateToProps)(OrgDetailsPageImpl) as any);

const DetailsRow = ({label, value}) => {
    return <div className="details">
        <div className="label">{label}</div>
        <div className="value">{value || 'NA'}</div>
    </div>;
};

const ImageDetailsRow = ({label, link}) => {
    return <div className="details">
        <div className="label">{label}</div>
        <img alt="org-image" height={'100'} width={'100'} src={link}/>
    </div>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Organization/OrgDetailsPage.tsx